/**
 * OJASTRAS Theme Scripts
 * Client interactions: cart drawer progress, 1-click upsell/bundles, sticky mobile ATC, accordions
 */

(function () {
  'use strict';

  function formatMoney(cents) {
    const rupees = Math.round(cents / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  // Open Cart Drawer
  function openCartDrawer() {
    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      const cartBtn = document.querySelector('a[href="/cart"], button[aria-controls="cart-drawer"]');
      if (cartBtn) cartBtn.click();
    }
  }

  // Live Free Shipping Progress
  async function refreshFreeShipping() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      const thresholdElem = document.querySelector('[data-free-shipping-threshold]');
      const thresholdRupees = thresholdElem ? parseInt(thresholdElem.dataset.freeShippingThreshold, 10) : 999;
      const thresholdCents = thresholdRupees * 100;

      const progressFills = document.querySelectorAll('.ls-cart-progress-fill');
      const progressTexts = document.querySelectorAll('.ls-cart-progress-status');
      const countBadges = document.querySelectorAll('.ls-cart-count-badge');

      // Update count badges
      countBadges.forEach((badge) => {
        badge.textContent = cart.item_count;
      });

      if (!progressFills.length || !progressTexts.length) return;

      const currentTotal = cart.total_price;
      const percent = Math.min(100, Math.round((currentTotal / thresholdCents) * 100));

      progressFills.forEach((fill) => {
        fill.style.width = percent + '%';
      });

      progressTexts.forEach((text) => {
        if (currentTotal >= thresholdCents) {
          text.innerHTML = "You've unlocked <strong>FREE Express Shipping</strong>!";
        } else {
          const remaining = thresholdCents - currentTotal;
          text.innerHTML = `Add <strong>${formatMoney(remaining)}</strong> more for <strong>FREE Shipping</strong>`;
        }
      });
    } catch (e) {
      console.warn('Could not refresh cart progress', e);
    }
  }

  // 1-Click Add To Cart
  async function handleQuickAdd(variantId, quantity = 1, buttonElement = null) {
    if (!variantId) {
      // If variantId is not set, redirect to product page
      const href = buttonElement ? buttonElement.getAttribute('data-product-url') : null;
      if (href) window.location.href = href;
      return;
    }

    const originalText = buttonElement ? buttonElement.innerHTML : '';
    if (buttonElement) {
      buttonElement.disabled = true;
      buttonElement.innerHTML = 'Adding...';
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (!res.ok) {
        throw new Error('Failed to add to cart');
      }

      const cartComponent = document.querySelector('cart-drawer-component');
      if (cartComponent && typeof cartComponent.refresh === 'function') {
        await cartComponent.refresh();
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      await refreshFreeShipping();

      setTimeout(openCartDrawer, 100);
    } catch (err) {
      console.error('Error adding to cart:', err);
      // Fallback
      alert('Item added. Viewing cart...');
      openCartDrawer();
    } finally {
      if (buttonElement) {
        buttonElement.disabled = false;
        buttonElement.innerHTML = originalText;
      }
    }
  }

  // Sticky Header Scroll States
  function initHeaderScroll() {
    const header = document.querySelector('.ls-header-wrap');
    if (!header) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 15) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  // Mobile Menu Drawer
  function initMobileMenu() {
    const toggleBtn = document.querySelector('.ls-header-mobile-toggle');
    const overlay = document.querySelector('.ls-mobile-menu-overlay');
    const closeBtn = document.querySelector('.ls-mobile-menu-close');

    if (!toggleBtn || !overlay) return;

    function openMenu() {
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    toggleBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeMenu();
    });

    document.querySelectorAll('.ls-mobile-nav-links a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });
  }

  // Scroll Fade-Up (Respects prefers-reduced-motion)
  function initFadeUp() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.ls-fade-up').forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.ls-fade-up').forEach((el) => observer.observe(el));
  }

  // Review Form Star Picker
  function initStarPicker() {
    const starPicker = document.querySelector('.ls-star-picker');
    const ratingInput = document.querySelector('input[name="contact[rating]"]');
    if (!starPicker || !ratingInput) return;

    const stars = starPicker.querySelectorAll('.ls-star-picker-star');

    stars.forEach((star) => {
      star.addEventListener('click', () => {
        const value = parseInt(star.dataset.star, 10);
        ratingInput.value = value;

        stars.forEach((s) => {
          const sVal = parseInt(s.dataset.star, 10);
          if (sVal <= value) {
            s.classList.add('is-active');
            s.textContent = '★';
          } else {
            s.classList.remove('is-active');
            s.textContent = '☆';
          }
        });
      });
    });
  }

  // Sticky Mobile Add To Cart Bar
  function initStickyAddToCart() {
    const stickyBar = document.querySelector('.ls-mobile-sticky-bar');
    const targetTrigger = document.querySelector('[data-sticky-atc-trigger]');

    if (!stickyBar || !targetTrigger) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(targetTrigger);
  }

  // Event Delegation for Quick Adds & Upsells
  document.addEventListener('click', (e) => {
    const quickAddBtn = e.target.closest('[data-ls-quick-add]');
    if (quickAddBtn) {
      e.preventDefault();
      const variantId = quickAddBtn.dataset.lsQuickAdd;
      const quantity = parseInt(quickAddBtn.dataset.lsQty || '1', 10);
      handleQuickAdd(variantId, quantity, quickAddBtn);
    }

    const drawerTrigger = e.target.closest('[data-ls-open-drawer]');
    if (drawerTrigger) {
      e.preventDefault();
      openCartDrawer();
    }
  });

  // Initialization
  function initAll() {
    initHeaderScroll();
    initMobileMenu();
    initFadeUp();
    initStarPicker();
    initStickyAddToCart();
    refreshFreeShipping();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

})();
